import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompraFotoComponent } from './compra-foto/compra-foto.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'compra-foto',
    pathMatch: 'full'
  },
  {
    path: 'compra-foto',
    component: CompraFotoComponent
  },
  {
    path: 'compra-foto/:status',
    component: CompraFotoComponent
  },
  {
    path: '**',
    redirectTo: 'compra-foto'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
